import { render } from "./ProductListTags.vue?vue&type=template&id=4d136a44&lang=pug"
import script from "./ProductListTags.vue?vue&type=script&lang=js"
export * from "./ProductListTags.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__